import { css } from '@emotion/react';

export const widgetContent = (showEmptyState?: boolean) => css`
  display: flex;
  flex-direction: row;
  overflow: hidden;
  height: 100%;

  ${showEmptyState
    ? css`
        svg {
          height: 120px;
        }
      `
    : ''}
`;

export const countContainer = css`
  padding-right: var(--fabric-geometry-comfortable-space-padding-xl);
  width: fit-content;
  height: 100%;
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

export const countText = css`
  font-size: var(--fabric-geometry-comfortable-text-jumbo-sm);
`;
export const statusText = css`
  color: var(--fabric-color-neutral-60);
`;

export const listContainer = css`
  width: 100%;
  height: 100%;
`;

export const listBorderStyle = css`
  border: 1px solid var(--fabric-color-border-subtle);
  border-radius: var(--fabric-geometry-standard-radius-md);
  overflow: hidden;
`;

export const emptyStateListWrapper = css`
  padding: var(--fabric-space-gap-sm) 0 0 0;
`;
